import I18n from 'i18n-js'
import en from '../../../../config/locales/en.yml'

I18n.translations = { ...en }
I18n.defaultLocale = 'en'

const t = (key, data) => I18n.t(key, data)

export default I18n
export { t }
